import { FormKitValidationRule } from '@formkit/validation';

import { i18n } from '@/i18n';
import { FormKitGlobalRule } from '@/types/interfaces/ValidationRule.interface';

const rule: FormKitValidationRule = (_, attempts: number): boolean => attempts === null;
rule.skipEmpty = false;
rule.blocking = false;

/** Only for global use. @see https://formkit.com/essentials/validation#adding-a-rule-globally */
export const AttemptsFormKitRule: FormKitGlobalRule = {
  name: 'attempts',
  rule,
  message: ({ args }) => {
    if (args[0] === 0) return i18n.global.t('components.otp.phone.attempts_exceeded');
    return i18n.global.t('components.otp.phone.invalid', args);
  },
};

/** Only for global use. @see https://formkit.com/essentials/validation#adding-a-rule-globally */
export const ResendAttemptsFormKitRule: FormKitGlobalRule = {
  name: 'resendAttempts',
  rule,
  message: ({ args }) => i18n.global.t('components.otp.phone.resend_attempts', args),
};

/** Only for global use. @see https://formkit.com/essentials/validation#adding-a-rule-globally */
export const AttemptsUnexposedFormKitRule: FormKitGlobalRule = {
  name: 'attemptsUnexposed',
  rule,
  message: ({ args }) => {
    if (args[0] === 0) return i18n.global.t('components.otp.phone.attempts_exceeded');
    return i18n.global.t('components.otp.phone.invalid_without_attempts', args);
  },
};
